import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <LandingPage data-id="element-1" />
    </LanguageProvider>;
}